import { Signal, signal, computed } from '@angular/core';

export interface AlertState {
  type: 'success' | 'warning' | 'error' | 'info';
  title?: string;
  message: string;
}

export class AlertStore {
  private alertSignal = signal<AlertState | null>(null);
  private alertTimer: any = null;

  readonly alert: Signal<AlertState | null> = this.alertSignal.asReadonly();
  readonly showAlertSignal = computed(() => this.alertSignal() !== null);
  readonly alertType = computed(() => this.alertSignal()?.type ?? 'info');
  readonly alertTitle = computed(() => this.alertSignal()?.title);
  readonly alertMessage = computed(() => this.alertSignal()?.message ?? '');

  clearAlert(): void {
    if (this.alertTimer) {
      clearTimeout(this.alertTimer);
      this.alertTimer = null;
    }
    this.alertSignal.set(null);
  }

  showAlert(type: AlertState['type'], message: string, title?: string): void {
    const current = this.alertSignal()?.type;
    if (current === 'error' && type !== 'error') return;

    if (this.alertTimer) {
      clearTimeout(this.alertTimer);
      this.alertTimer = null;
    }

    this.alertSignal.set({ type, title, message });

    if (type === 'success' || type === 'info') {
      this.alertTimer = setTimeout(() => {
        this.clearAlert();
      }, 5000);
    }
  }

  setError(message: string, title = 'Error'): void {
    this.showAlert('error', message, title);
  }

  setSuccess(message: string, title = 'Éxito'): void {
    this.showAlert('success', message, title);
  }

  setWarning(message: string, title = 'Advertencia'): void {
    this.showAlert('warning', message, title);
  }

  setInfo(message: string, title = 'Información'): void {
    this.showAlert('info', message, title);
  }
}
